<template>
  <div class="transportation-container row row-cols-2 row-cols-1 m-0 mb-3">
    <div class="transportation-container__item-1 p-0 d-flex flex-row justify-content-between col-sm-12 col-lg-6 col-xxl-2">
      <div class="w-100 d-flex flex-column align-items-center justify-content-center">
        <div class="transportation-container__item-1__time">
          {{ transportation.pickup_time }} - {{ transportation.drop_off_time }}
        </div>
        <div class="transportation-container__item-1__travel-time" v-if="transportation?.travel_time">
          {{ $t('duration') }} {{ transportation.travel_time.split(':')[0] }}{{$t('shortened_hours')}}  {{ transportation.travel_time.split(':')[1] }}{{$t('shortened_minutes')}}
        </div>
      </div>
      <div class="transportation-container__line"></div>
    </div>

    <div class="transportation-container__item-2 p-0 d-flex flex-row justify-content-between col-sm-12 col-lg-6 col-xxl-3">
      <div class="w-100 d-flex flex-column justify-content-center align-items-xxs-center align-items-sm-center align-items-xxl-start p-4">
        <div class="transportation-container__item-2__route">{{ transportation.title }}</div>
        <div class="transportation-container__item-2__map d-flex flex-row" data-bs-toggle="modal" :data-bs-target="`#transportation-route-map-${transportation.id}`">
          <img src="/assets/images/map-icon.svg" alt=""/>
          <div class="ms-2">{{ $t('journey_map') }}</div>
        </div>
      </div>
      <div class="transportation-container__line"></div>
    </div>

    <div class="transportation-container__item-3 p-0 d-flex flex-row justify-content-between align-items-center col-sm-12 col-lg-6 col-xxl-4">
      <VehicleCardFreeItemWrapperComponent class="column-gap p-4 justify-content-center w-100"/>
      <div class="transportation-container__line"></div>
    </div>

    <div class="transportation-container__item-4 p-0 d-flex align-items-center justify-content-center col-sm-12 col-lg-6 col-xxl-3">
        <div class="transportation-container__item-4__inner d-flex flex-column justify-content-center align-items-xxs-center h-100 align-items-end">
          <div class="transportation-container__item-4__inner__cost">
            {{ parseFloat((transportation.totals.tax_total).toFixed(2)) }} {{$t('symbol_eur')}}
          </div>
          <div class="transportation-container__item-4__inner__label">
            {{ $t('price_per_person') }}
          </div>
        </div>
        <div>
          <ButtonComponent class="transportation-button" @click="$emit('select-transportation', {transportationId: transportation.id})">
            <template v-slot:btnContent>
              {{ $t(placeholder) }}
            </template>
          </ButtonComponent>
        </div>
      </div>

    <ModalComponent :show-title="false" :id-data="`transportation-route-map-${transportation.id}`">
      <template #body-content>
        <TransportationStopsModalContentComponent :data="transportation"/>
      </template>
    </ModalComponent>
  </div>
</template>

<script lang="ts">
import {defineComponent, type PropType} from "vue";

import type {IApiResponseTransportation} from "@/interfaces/apiResponseInterfaces/IApiResponseTransportation.interface";

// @ts-ignore
import VehicleCardFreeItemWrapperComponent from "../vehicleCardFreeItemWrapper/VehicleCardFreeItemWrapperComponent.vue";
// @ts-ignore
import ButtonComponent from "../Button/ButtonComponent.vue";
// @ts-ignore
import ModalComponent from "../modal/ModalComponent.vue";
// @ts-ignore
import TransportationStopsModalContentComponent from "../transportationStopsModalContent/TransportationStopsModalContentComponent.vue";



export default defineComponent({
  name: 'TransportationItemComponent',
  components: {
    TransportationStopsModalContentComponent,
    VehicleCardFreeItemWrapperComponent,
    ButtonComponent,
    ModalComponent,
  },

  emits: ['select-transportation'],
  props: {
    placeholder: {
      type: String,
      required: true
    },
    isRoundTrip: {
      type: Boolean,
      required: true
    },
    transportation: {
      type: Object as PropType<IApiResponseTransportation>,
      required: true,
    }
  },

  data() {
    return {

    }
  },
})
</script>

<style lang="scss" scoped>
@import './transportationItem.scss';
</style>